import { render, staticRenderFns } from "./CbsChatbot.vue?vue&type=template&id=28f6028c&scoped=true"
import script from "./CbsChatbot.vue?vue&type=script&lang=js"
export * from "./CbsChatbot.vue?vue&type=script&lang=js"
import style0 from "./CbsChatbot.vue?vue&type=style&index=0&id=28f6028c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6028c",
  null
  
)

export default component.exports